
import React, { useEffect, useState, useCallback } from 'react';
// Icons
import {
  ArrowBack as ArrowLeft,
  Close as X,
  CheckCircle,
  AccessTime as Clock,
  Description as FileText,
  Visibility as Eye,
  ThumbUp as ThumbUpIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Videocam as Video,
  Phone as PhoneIcon,
  LocationOn as MapPin,
  ArrowBack as ArrowBackIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import SearchIcon from '@mui/icons-material/Search';

import Cancel from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VideoCallIcon from '@mui/icons-material/VideoCall';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// MUI Components
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Avatar,
  Rating,
  Stack,
  Badge,
  InputAdornment,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { cancelAppointment, deleteAppointment, getAppointments } from '../../service/appointment';
import { useNavigate } from 'react-router-dom';
import { getReviewByAppointmentId, addReview, updateReview, deleteReview } from '../../service/review';
import { initiateIVRCall } from '../../service/ivr';


const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#FFD700',
  },
  '& .MuiRating-iconHover': {
    color: '#FFED85',
  },
});

const MyAppointments = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  const navigate = useNavigate();

  // Typography styles with Inter font
  const typographyStyles = {
    fontFamily: theme.typography.fontFamily,
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
    },
    '& button, & .MuiButton-root': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
    },
    '& .MuiTypography-root': {
      fontFamily: theme.typography.fontFamily,
    }
  };

  const [activeTab, setActiveTab] = useState(0);
  const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [feedbackTab, setFeedbackTab] = useState(0);
  const [rating, setRating] = useState(0);
  const [feedbackTags, setFeedbackTags] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [review, setReview] = useState('');
  const [recommend, setRecommend] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success' | 'error' | 'info' | 'warning'
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [appointments, setAppointments] = useState([]);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [cancelRemark, setCancelRemark] = useState('');

  const [reviews, setReviews] = useState({});
  const [isLoadingReview, setIsLoadingReview] = useState(false);
  const [editingReview, setEditingReview] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null); // 'pending-feedback' | 'completed' | null
  const [copiedAppointmentId, setCopiedAppointmentId] = useState(null);
  // Debug effect for activeFilter
  useEffect(() => {
    console.log('activeFilter changed:', activeFilter);
  }, [activeFilter]);


  // const fetchAppointments = async () => {
  //   try {
  //     const data = await listAppointments(userId);
  //     console.log("Appointments API raw data:", data);
  //     console.log("Appointments count:", data?.length);

  //     console.log("Appointments API raw data:", data);
  //     console.log("Appointments count:", data?.length);

  //     // Map API data to UI-friendly format
  //     const mapped = data.map(appt => ({
  //       id: appt?.id,
  //       doctorName: appt?.doctor_name || `Dr. ${appt?.doctor_id}`, // fallback
  //       specialty: appt?.specialty || "General",
  //       hospital: appt?.hospital || "Hospital Name",
  //       // Convert slot_date (UTC) → readable date in local time
  //       date: new Date(appt?.slot_date).toLocaleDateString("en-GB", {
  //         day: "numeric",
  //         month: "short",
  //         year: "numeric",
  //       }),
  //       time: `${appt?.start_time.slice(0, 5)} - ${appt?.end_time.slice(0, 5)}`,
  //       type: appt?.consultation_type,
  //       status: appt?.status,
  //       avatar: appt?.avatar || "",
  //       meetLink: appt?.meet_link,
  //       rawDate: appt?.slot_date, // keep raw ISO date for filtering
  //       startTime: appt?.start_time,
  //     }));

  //     setAppointments(mapped);
  //   } catch (error) {
  //     console.error("Failed to fetch appointments:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (userId) fetchAppointments();
  // }, [userId]);

  const formatCancelledAt = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString); // must be a proper ISO string with Z/offset

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",   // <-- do the conversion here, not manually
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const fetchAppointments = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const data = await getAppointments({
        userId: user?.id,
        appName: "echoshine", // change if your backend expects another app name
      });

      console.log("Appointments API raw data:", data);

      const mapped = (data || []).map((appt) => ({
        id: appt.id,
        doctorName: appt.doctor_name || `Dr. ${appt.doctor_id}`,
        specialty: appt.specialty || "General",
        hospital: appt.hospital || "",
        date: new Date(appt.slot_date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        }),
        time: `${appt.start_time?.slice(0, 5)} - ${appt.end_time?.slice(0, 5)}`,
        type: appt.consultation_type,
        status: appt.status,
        avatar: appt.avatar || "",
        meetLink: appt.meet_link,
        rawDate: appt.slot_date,
        startTime: appt.start_time,

        // ADD THESE
        cancelledBy: appt.cancellation_triggered_by,
        cancelledAt: appt.cancelled_at,
        cancellationRemark: appt.cancellation_remark,
        doctor_id: appt.doctor_id,
        customer_id: appt.customer_id,
        cancellationTriggeredBy: appt.cancellation_triggered_by,

      }));

      setAppointments(mapped);
    } catch (error) {
      console.error("Failed to fetch appointments:", error);
      setAppointments([]);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchAppointments();
    }
  }, [userId]);



  console.log("selectedAppointment", selectedAppointment)

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const now = new Date();
  const isMoreThan2HoursBefore = (startTime, slotDate) => {
    if (!startTime || !slotDate) return false;

    const now = new Date();


    const appointmentDateTime = new Date(
      `${slotDate.split("T")[0]}T${startTime}`
    );

    const diff = appointmentDateTime - now;

    const TWO_HOURS = 2 * 60 * 60 * 1000;

    return diff > TWO_HOURS; // ✅ true = show cancel
  };

  const handleCancelClick = (appt) => {
    setAppointmentToCancel(appt);
    setCancelDialogOpen(true);
  };

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
    setAppointmentToCancel(null);
    setCancelRemark('');
  };

  const handleCopyMeetLink = async (e, appointment) => {
    e.stopPropagation();

    if (!appointment.meetLink) return;

    try {
      await navigator.clipboard.writeText(appointment.meetLink);

      console.log("Meet link copied:", appointment.meetLink);

      // If you already have Snackbar:
      // setSnackbar({
      //   open: true,
      //   message: "Meet link copied!",
      //   severity: "success",
      // });
    } catch (error) {
      console.error("Failed to copy meet link:", error);
    }
  };

  const handleConfirmCancel = async () => {
    if (!appointmentToCancel) return;

    try {
      // Call the cancel appointment API with remark

      const cancelledAt = new Date()
        .toLocaleString("sv-SE", {
          timeZone: "Asia/Kolkata",
          hour12: false,
        })
        .replace(" ", "T");

      console.log("Cancelling appointment at IST:", cancelledAt);

      // await cancelAppointment(appointmentToCancel.id, cancelRemark, 'echoshine', cancelledAt
      // );
      await cancelAppointment(
        appointmentToCancel.id,
        cancelRemark,
        "echoshine",
        cancelledAt
      );
      setShowSnackbar({
        open: true,
        message: 'Appointment cancelled successfully',
        severity: 'success'
      });
      // Refresh the appointments list
      fetchAppointments();
    } catch (error) {
      console.error('Failed to cancel appointment:', error);
      setShowSnackbar({
        open: true,
        message: 'Failed to cancel appointment',
        severity: 'error'
      });
    } finally {
      handleCancelDialogClose();
    }
  };

  // const upcomingAppointments = appointments?.filter((appt) => {
  //   const apptDateTime = new Date(`${appt.rawDate.split("T")[0]}T${appt.startTime}`);
  //   return apptDateTime >= now;
  // });
  const upcomingAppointments = appointments?.filter((appt) => {
    const statusLower = appt.status?.toLowerCase().trim();

    if (statusLower !== "scheduled") return false;
    if (!appt.rawDate || !appt.startTime) return false;

    // Appointment date
    const appointmentDate = new Date(
      `${appt.rawDate.split("T")[0]}T00:00:00`
    );

    // Tomorrow at 00:00
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Only tomorrow or later
    return appointmentDate >= tomorrow;
  });

  // const scheduledAppointments = appointments?.filter(appt =>
  //   appt.status === 'scheduled'
  // );


  const scheduledAppointments = appointments?.filter((appt) => {
    if (appt.status?.toLowerCase() !== "scheduled") return false;
    if (!appt.rawDate || !appt.startTime) return false;

    const appointmentDate = new Date(
      `${appt.rawDate.split("T")[0]}T00:00:00`
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return appointmentDate.getTime() === today.getTime();
  });
  const pastAppointments = appointments?.filter((appt) => {
    const apptDateTime = new Date(`${appt.rawDate.split("T")[0]}T${appt.startTime}`);
    return apptDateTime < now && appt.status === 'completed';
  });

  let filteredAppointments = activeTab === 0 ? upcomingAppointments : pastAppointments;

  // Debug logging
  console.log('Active Tab:', activeTab, 'Active Filter:', activeFilter);
  console.log('All appointments:', appointments);
  console.log('Past appointments:', pastAppointments);
  console.log('Reviews:', reviews);

  // Apply additional filtering for the Past tab based on activeFilter
  if (activeTab === 1) {
    if (activeFilter === 'scheduled') {
      filteredAppointments = scheduledAppointments;
    } else if (activeFilter === 'pending-feedback') {
      const pendingFeedback = pastAppointments.filter(appt => {
        const hasNoReview = !reviews[appt.id];
        console.log('Appointment:', appt.id, 'Status:', appt.status, 'Has Review:', !hasNoReview, 'Review:', reviews[appt.id]);
        return hasNoReview;
      });
      console.log('Pending Feedback Appointments:', pendingFeedback);
      filteredAppointments = pendingFeedback;
    } else if (activeFilter === 'completed') {
      filteredAppointments = pastAppointments.filter(appt =>
        reviews[appt.id]
      );
    }
    else if (activeFilter === "cancelled") {
      filteredAppointments = appointments
        .filter(appt => appt.status?.toLowerCase() === "cancelled")
        .sort((a, b) => {
          const dateA = a.cancelledAt ? new Date(a.cancelledAt).getTime() : 0;
          const dateB = b.cancelledAt ? new Date(b.cancelledAt).getTime() : 0;
          return dateB - dateA;
        });
    }
  }

  const formatSlotToAMPM = (slot) => {
    if (!slot) return ""; // safety check

    const [start, end] = slot.split("-").map(s => s.trim()); // split by '-' and remove spaces
    if (!start || !end) return slot; // fallback if malformed

    const formatTime = (time24) => {
      const [hourStr, minute] = time24.split(":");
      let hour = parseInt(hourStr, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12;
      if (hour === 0) hour = 12;
      return `${hour}:${minute} ${ampm}`;
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  };

  const finalFilteredAppointments = filteredAppointments.filter((appt) => {
    const formattedTime = formatSlotToAMPM(appt.time);

    return (
      appt.doctorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.specialty.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formattedTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.time.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const getTypeIcon = (type) => {
    const iconStyle = { fontSize: '1rem' };
    switch (type) {
      case 'Video Consultation': return <Video style={iconStyle} />;
      case 'Phone Call': return <PhoneIcon style={iconStyle} />;
      case 'In-Person': return <MapPin style={iconStyle} />;
      default: return <FileText style={iconStyle} />;
    }
  };

  const feedbackTagOptions = [
    'Helpful', 'Good Listener', 'Professional', 'Knowledgeable',
    'Empathetic', 'Thorough', 'Punctual', 'Clear Communication'
  ];

  const handleFeedbackTagToggle = (tag) => {
    setFeedbackTags(prev =>
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  const handleEditReview = async (appointment) => {
    setSelectedAppointment(appointment);

    try {
      // Force fetch the latest review data
      const existingReview = await getReviewByAppointmentId(appointment.id);

      if (existingReview) {
        // Set all form fields with the fetched data
        setRating(existingReview?.data?.ratings || 0);
        setReview(existingReview?.data?.notes || '');
        setRecommend(existingReview?.data?.is_recommended ? 'yes' : 'no');
        setFeedbackTags(existingReview?.data?.experience || '')
        setEditingReview(true)
      } else {
        // If no review found, reset to new review state
        setRating(0);
        setReview('');
        setRecommend(null);
        setEditingReview(false);
      }

      // Only open the dialog after state is updated
      setOpenFeedbackDialog(true);
      setFeedbackTab(1);
    } catch (error) {
      console.error('Error fetching review:', error);
      // Still open dialog but in a clean state
      setRating(0);
      setReview('');
      setRecommend(null);
      setEditingReview(false);
      setOpenFeedbackDialog(true);
      setFeedbackTab(1);
    }
  };


  const handleDeleteAppointment = async (appointment) => {
    if (!appointment?.id) {
      console.error("Appointment ID not found");
      return;
    }

    // ✅ Show confirmation first
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this appointment?"
    );
    if (!confirmDelete) return; // User clicked "Cancel"

    try {
      // You can pass any data you want to update for deletion
      const data = { status: 'cancelled' }; // for example, marking status as cancelled
      const res = await deleteAppointment(appointment.id, data);

      console.log('Appointment deleted/updated:', res);

      // ✅ Show success alert
      alert("Appointment deleted successfully");

      // Optional: refresh the appointments list
      fetchAppointments(); // or your function to reload
    } catch (err) {
      console.error('Failed to delete appointment:', err);
      const errorMsg = err?.message || 'Failed to delete appointment';
      alert(errorMsg);
    }
  };


  const handleDeleteReview = async (appointment) => {
    if (!window.confirm('Are you sure you want to delete your review?')) {
      return;
    }

    setIsLoadingReview(true);

    try {
      await deleteReview(appointment.id);

      // Update the reviews state to remove the deleted review
      setReviews(prev => {
        const newReviews = { ...prev };
        delete newReviews[appointment.id];
        return newReviews;
      });

      // Show success message
      setShowSnackbar({
        open: true,
        message: 'Review deleted successfully',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error deleting review:', error);
      setShowSnackbar({
        open: true,
        message: 'Failed to delete review',
        severity: 'error'
      });
    } finally {
      setIsLoadingReview(false);
    }
  };

  const fetchReview = useCallback(async (appointmentId) => {
    if (!appointmentId) return null;

    try {
      const review = await getReviewByAppointmentId(appointmentId);
      setReviews(prev => ({
        ...prev,
        [appointmentId]: review
      }));
      return review;
    } catch (error) {
      console.error('Error fetching review:', error);
      return null;
    }
  }, []);

  useEffect(() => {
    const loadReviews = async () => {
      const reviewsMap = {};

      for (const appt of appointments) {
        if (appt.status === 'completed') {
          const review = await fetchReview(appt.id);
          if (review) {
            reviewsMap[appt.id] = review;
          }
        }
      }

      setReviews(reviewsMap);
    };

    if (appointments.length > 0) {
      loadReviews();
    }
  }, [appointments, fetchReview]);



  const handleSubmitFeedback = async () => {
    if (!selectedAppointment || !rating || recommend === null) return;

    setIsLoadingReview(true);
    console.log("feedbackTags", feedbackTags)

    try {
      const reviewData = {
        appointment_id: selectedAppointment.id,
        ratings: rating,
        notes: review,
        experience: feedbackTags,
        is_recommended: recommend === 'yes'
      };


      let result;
      if (editingReview) {
        result = await updateReview(selectedAppointment.id, reviewData);
      } else {
        result = await addReview(reviewData);
      }

      setReviews(prev => ({
        ...prev,
        [selectedAppointment.id]: result
      }));

      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
        setOpenFeedbackDialog(false);
        setEditingReview(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting review:', error);
    } finally {
      setIsLoadingReview(false);
    }
  };


  const handleViewDetails = (appointment) => {
    setSelectedAppointment(appointment);
    setOpenFeedbackDialog(true);
    setFeedbackTab(0);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setActiveFilter(null); // Reset filter when switching tabs
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, finalFilteredAppointments.length - page * rowsPerPage);

  // Custom Alert component for Snackbar
  // const Alert = React.forwardRef(function Alert(props, ref) {
  //   return <Alert elevation={6} ref={ref} variant="filled" {...props}
  //    sx={{ fontFamily: theme.typography.fontFamily }} />;
  // });

  const APPOINTMENT_TABS = [
    {
      value: "upcoming",
      label: "Upcoming",
      icon: <CalendarMonthIcon />,
    },
    {
      value: "scheduled",
      label: "Scheduled",
      icon: <AccessTimeIcon />,
    },
    {
      value: "pending-feedback",
      label: "Pending Feedback",
      icon: <StarIcon />,
    },
    {
      value: "completed",
      label: "Completed",
      icon: <CheckCircle />,
    },
    {
      value: "cancelled",
      label: "Cancelled",
      icon: <Cancel />,
    },
  ];

  const selectedTab =
    APPOINTMENT_TABS.find(
      (tab) => tab.value === (activeFilter ?? "upcoming")
    ) ?? APPOINTMENT_TABS[0];

  const getEffectiveStatus = (appointment) => {
    if (appointment.status.toLowerCase() !== 'scheduled') {
      return appointment.status;
    }

    if (!appointment.date || !appointment.time) {
      return appointment.status;
    }

    // appointment.date → YYYY-MM-DD
    // appointment.time → e.g. "10:30 AM"
    const [time, modifier] = appointment.time.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    const appointmentDateTime = new Date(appointment.date);
    appointmentDateTime.setHours(hours, minutes, 0, 0);

    const now = new Date();

    if (appointmentDateTime < now) {
      return 'not attended';
    }

    return appointment.status;
  };

  const handleConsultationClick = async (e, appointment) => {
    e.stopPropagation();
    if (!isModeEnabled(appointment)) return;

    try {
      if (appointment.type?.toLowerCase() === 'audio') {
        await initiateIVRCall(appointment.doctor_id, appointment.customer_id);
      }
      if (appointment.type?.toLowerCase() === 'video' && appointment.meetLink) {
        window.open(appointment.meetLink, '_blank');
      }
    } catch (err) {
      console.error('Failed to start consultation', err);
    }
  };

  // handles the 7 AM → end time clickability window
  const isModeEnabled = (appointment) => {
    const now = new Date();
    const appointmentDate = appointment.rawDate.split("T")[0];
    const sevenAM = new Date(`${appointmentDate}T07:00:00`);
    const endTime = appointment.time.split(" - ")[1];
    const appointmentEnd = new Date(`${appointmentDate}T${endTime}:00`);
    return now >= sevenAM && now <= appointmentEnd;
  };

  // hides chip after appointment end time / for non-scheduled statuses
  const shouldShowModeChip = (appointment) => {
    if (appointment.status?.toLowerCase() !== "scheduled") return false;
    const now = new Date();
    const appointmentDate = appointment.rawDate.split("T")[0];
    const endTime = appointment.time.split(" - ")[1];
    const appointmentEnd = new Date(`${appointmentDate}T${endTime}:00`);
    return now <= appointmentEnd;
  };

  const isFutureAppointment = (appointment) => {
    const { slot_date, start_time, status } = appointment;
    if (!slot_date || !start_time) {
      console.warn("Missing slot_date or start_time:", appointment);
      return false;
    }
    // starting an IVR call for audio consultations or opening the meeting link for video consultations


    const slotDateTime = new Date(`${slot_date.split("T")[0]}T${start_time}`);
    const now = new Date();

    const future = slotDateTime > now && status.toLowerCase() === "scheduled";

    console.log(
      `Appointment ID: ${appointment.id}, Status: ${status}, Slot: ${slotDateTime}, Now: ${now}, Render Delete: ${future}`
    );

    return future;
  };
  const showModeColumn = finalFilteredAppointments.some(
    (appointment) => shouldShowModeChip(appointment)
  );

  return (
    <Box sx={[{
      flexGrow: 1,
      p: { xs: 1, sm: 2, md: 3 },
      maxWidth: '100%',
      overflowX: 'hidden',
      fontFamily: theme.typography.fontFamily,
      background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
    }, typographyStyles]}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1.5}
        mb={3}
      >

        <Typography variant="h6" sx={{ fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
          My Appointments
        </Typography>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: '#F0F5FF',
            width: 40,
            height: 40,
            borderRadius: '50%',
            color: '#0B2D6B',
            '&:hover': {
              backgroundColor: '#E0EBFF'
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      </Stack>

      <Stack
        spacing={3}
        sx={{ mb: { xs: 2, sm: 3 }, px: 3, pt: 2 }}
      >
        <Box sx={{ borderColor: "divider", mb: 2, display: "flex", justifyContent: "space-between", background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>

          <Tabs
            value={activeFilter ?? "upcoming"} // ✅ reuse existing state
            onChange={(_, newValue) => {
              console.log("Tab clicked:", newValue);

              // 🔁 SAME logic as Box onClick
              if (newValue === "upcoming") {
                setActiveTab(0);
                setActiveFilter(null);
              } else if (newValue === "scheduled") {
                setActiveTab(1);
                setActiveFilter("scheduled");
              } else if (newValue === "pending-feedback") {
                setActiveTab(1);
                setActiveFilter("pending-feedback");
              } else if (newValue === "completed") {
                setActiveTab(1);
                setActiveFilter("completed");
              }
              else if (newValue === "cancelled") {
                setActiveTab(1);
                setActiveFilter("cancelled");
              }
              setPage(0);
            }}
            textColor="primary"
            indicatorColor="primary"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.9rem",
                minHeight: 48,
              },
              "& .MuiTab-wrapper": {
                flexDirection: "row",
                gap: 1,
              },
            }}
          >

            <Tab
              value="upcoming"
              icon={<CalendarMonthIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={`Upcoming (${upcomingAppointments.length})`}
            />

            <Tab
              value="scheduled"
              icon={<AccessTimeIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={`Scheduled (${scheduledAppointments.length})`}
            />

            <Tab
              value="pending-feedback"
              icon={<StarIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={`Pending Feedback (${pastAppointments.filter(appt => !reviews[appt.id]).length})`}
            />

            <Tab
              value="completed"
              icon={<CheckCircle sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={`Completed (${pastAppointments.filter(appt => reviews[appt.id]).length})`}
            />
            <Tab
              value="cancelled"
              icon={<Cancel sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={`Cancelled (${appointments.filter(
                appt => appt.status?.toLowerCase() === "cancelled"
              ).length
                })`}
            />

          </Tabs>


          {/* <TextField
            size="small"
            placeholder="Search appointments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              minWidth: 200,
              mb: 2,
              '& .MuiInputBase-root': {
                height: 50,
              },
              '& .MuiInputBase-input': {
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }
            }}
          /> */}
        </Box>

        <Box sx={{ width: '100%', maxWidth: 300, }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Search appointments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              sx: {
                height: 36,
                '& input': {
                  py: 0.5,
                }
              }
            }}

            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                backgroundColor: 'background.paper',
              },
            }}
          />
        </Box>
        {/* <Box
          display="flex"
          flexWrap="wrap"
          gap={2}
          sx={{
            width: { xs: '70%', md: '80%' },
            px: 0,
            pt: 1,
            marginTop: '0px',
            boxSizing: 'border-box',
            marginLeft: '0px',
            '& > *': {
              flex: '1 1 250px',
              maxWidth: 'calc(25% - 16px)'
            }
          }}
        >
          {[
            {
              label: "Upcoming",
              count: upcomingAppointments.length,
              icon: <Clock />,
              color: "primary.light",
              tab: 0,
            },
            {
              label: "Scheduled",
              count: scheduledAppointments.length,
              icon: <Clock />,
              color: "info.light",
              tab: 1,
              filter: 'scheduled'
            },
            {
              label: "Pending Feedback",
              count: pastAppointments.filter(appt => !reviews[appt.id]).length,
              icon: <StarIcon />,
              color: "warning.light",
              tab: 1,
              filter: 'pending-feedback',
              badge: true,
              badgeColor: "error",
            },
            {
              label: "Completed",
              count: pastAppointments.filter(appt => reviews[appt.id]).length,
              icon: <CheckCircle />,
              color: "success.light",
              tab: 1,
              filter: 'completed'
            },
          ].map((card) => (
            <Paper
              key={card.label}
              elevation={0}
              onClick={() => {
                console.log('Card clicked:', card.label);
                setActiveTab(card.tab);
                // Set the appropriate filter based on which card was clicked
                if (card.filter) {
                  console.log(`Setting filter to ${card.filter}`);
                  setActiveFilter(card.filter);
                } else {
                  console.log('Clearing filter');
                  setActiveFilter(null);
                }
                setPage(0);
              }}
              sx={{
                p: { xs: 1.5, sm: 2 },
                borderRadius: 3,
                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                border: "1px solid #e0e0e0",
                flex: "1 1 30%",
                minWidth: 250,
                fontFamily: "inherit",
                display: "flex",
                alignItems: "center",
                gap: 2,
                cursor: "pointer",
                "&:hover": { boxShadow: 3 },
              }}
            >
              {card.badge ? (
                <Badge badgeContent={card.count} color={card.badgeColor} overlap="circular">
                  <Avatar
                    sx={{
                      bgcolor: card.color,
                      width: { xs: 40, sm: 56 },
                      height: { xs: 40, sm: 56 },
                      "& .MuiSvgIcon-root": {
                        fontSize: { xs: "1.25rem", sm: "1.5rem" },
                      },
                    }}
                  >
                    {card.icon}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  sx={{
                    bgcolor: card.color,
                    width: { xs: 40, sm: 56 },
                    height: { xs: 40, sm: 56 },
                    "& .MuiSvgIcon-root": {
                      fontSize: { xs: "1.25rem", sm: "1.5rem" },
                    },
                  }}
                >
                  {card.icon}
                </Avatar>
              )}
              <Box>
                <Typography variant={isMobile ? "h6" : "h5"}>{card.count}</Typography>
                <Typography variant={isMobile ? "caption" : "body2"} color="text.secondary">
                  {card.label}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box> */}

        {/* Appointments Table */}
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              overflow: 'hidden',
              p: { xs: 1, sm: 2 },
              fontFamily: 'inherit',
              borderRadius: 3,
              bgcolor: 'white',
              border: '1px solid #e0e0e0',
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5} mb={2}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  '& svg': {
                    fontSize: '1.4rem',
                  },
                  color: '#22c55e'
                }}
              >
                {selectedTab.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  lineHeight: 1,
                  fontSize: '1.1rem',
                  background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'
                }}
              >
                {selectedTab.label} Appointments
              </Typography>
            </Box>
            {/* <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{
                width: '100%',
                minHeight: 48,
                mb: 2,
                '& .MuiTabs-flexContainer': {
                  width: '100%',
                  justifyContent: 'stretch'
                },
                '& .MuiTab-root': {
                  flex: 1,
                  px: { xs: 1, sm: 2 },
                  py: { xs: 1, sm: 1.5 },
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  minHeight: 40,
                  textTransform: 'none',
                  position: 'relative',
                  '&:not(:last-of-type)::after': {
                    content: '""',
                    position: 'absolute',
                    right: 0,
                    height: '95%',
                    width: '1px',
                    bgcolor: (theme) => theme.palette.primary.main,
                  },
                },
              }}
            >
              <Tab label="Upcoming" sx={{ flex: 1, minWidth: 0 }} />
              <Tab label="Past" sx={{ flex: 1, minWidth: 0 }} />
            </Tabs> */}

            <TableContainer
              sx={{
                maxHeight: { xs: 'calc(100vh - 300px)', sm: 'none' },
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  height: 6,
                  width: 6,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'text.disabled',
                  borderRadius: 3,
                },
                '& .MuiTable-root': {
                  '& .MuiTableCell-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }
                }
              }}
            >
              <Table size={isMobile ? 'small' : 'medium'}>
                <TableHead>
                  <TableRow sx={{
                    background: 'linear-gradient(to bottom, #f4f4f4, #f9f9f9)', // very light shade
                  }}>
                    <TableCell>Doctor</TableCell>
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Specialty</TableCell>
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Date & Time</TableCell>
                    <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>Type</TableCell>
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Status</TableCell>
                    {/* <TableCell>Actions</TableCell> */}
                    {activeFilter !== "cancelled" && (
                      <TableCell>Actions</TableCell>
                    )}
                    {showModeColumn && (
                      <TableCell>Mode</TableCell>
                    )}
                    {activeFilter === "cancelled" && (
                      <TableCell>Cancellation Details</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {finalFilteredAppointments.length > 0 ? (
                    finalFilteredAppointments
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((appointment) => (
                        <TableRow key={appointment.id} sx={{ bgcolor: 'white', }}>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Avatar sx={{ bgcolor: 'primary.main' }}>
                                  {appointment.doctorName ? appointment.doctorName.charAt(0).toUpperCase() : '?'}
                                </Avatar>
                              </Box>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography
                                  variant={isMobile ? 'body2' : 'body1'}
                                  noWrap
                                  sx={{ fontWeight: isMobile ? 500 : 'normal' }}
                                >
                                  {appointment.doctorName}
                                </Typography>
                                {/* <Typography
                                  variant={isMobile ? 'caption' : 'body2'}
                                  color="text.secondary"
                                  noWrap
                                >
                                  {appointment.hospital}
                                </Typography> */}
                              </Box>
                            </Stack>
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                            <Typography variant={isMobile ? 'caption' : 'body2'}>
                              {appointment.specialty}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                            <Box>
                              <Typography variant={isMobile ? 'caption' : 'body2'}>
                                {appointment.date}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" display="block">
                                {formatSlotToAMPM(appointment.time)}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                              {getTypeIcon(appointment.type)}
                              <Typography variant={isMobile ? 'caption' : 'body2'}>
                                {appointment.type.toLowerCase() === 'video'
                                  ? 'Video Consultation'
                                  : appointment.type.toLowerCase() === 'phone'
                                    ? 'Phone Call'
                                    : appointment.type}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                            {/* <Chip
                              label={appointment.status.charAt(0).toUpperCase() + appointment.status.slice(1).toLowerCase()}
                              size={isMobile ? 'small' : 'medium'}
                              sx={{
                                backgroundColor: 'transparent',
                                border:
                                  appointment.status.toLowerCase() === 'completed'
                                    ? '1px solid green'
                                    : appointment.status.toLowerCase() === 'scheduled'
                                      ? '1px solid blue'
                                      : undefined,
                                color:
                                  appointment.status.toLowerCase() === 'completed'
                                    ? 'green'
                                    : appointment.status.toLowerCase() === 'scheduled'
                                      ? 'blue'
                                      : undefined,
                                '& .MuiChip-label': {
                                  px: { xs: 0.5, sm: 1 },
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                  color:
                                    appointment.status.toLowerCase() === 'completed'
                                      ? 'green'
                                      : appointment.status.toLowerCase() === 'scheduled'
                                        ? 'blue'
                                        : undefined,
                                },
                                borderRadius: 1
                              }}
                            /> */}
                            {(() => {
                              const effectiveStatus = getEffectiveStatus(appointment);
                              const lowerStatus = effectiveStatus.toLowerCase();

                              return (
                                <Chip
                                  label={
                                    effectiveStatus
                                      .split(' ')
                                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                      .join(' ')
                                  }
                                  size={isMobile ? 'small' : 'medium'}
                                  sx={{
                                    backgroundColor: 'transparent',
                                    border:
                                      lowerStatus === 'completed'
                                        ? '1px solid green'
                                        : lowerStatus === 'scheduled'
                                          ? '1px solid blue'
                                          : lowerStatus === 'not attended'
                                            ? '1px solid #d32f2f'
                                            : lowerStatus === 'cancelled'
                                              ? '1px solid red'
                                              : undefined,
                                    color:
                                      lowerStatus === 'completed'
                                        ? 'green'
                                        : lowerStatus === 'scheduled'
                                          ? 'blue'
                                          : lowerStatus === 'not attended'
                                            ? '#d32f2f'
                                            : lowerStatus === 'cancelled'
                                              ? 'red'
                                              : undefined,
                                    '& .MuiChip-label': {
                                      px: { xs: 0.5, sm: 1 },
                                      fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                      color:
                                        lowerStatus === 'completed'
                                          ? 'green'
                                          : lowerStatus === 'scheduled'
                                            ? 'blue'
                                            : lowerStatus === 'not attended'
                                              ? '#d32f2f'
                                              : lowerStatus === 'cancelled'
                                                ? 'red'
                                                : undefined,
                                    },
                                    borderRadius: 1,
                                  }}
                                />
                              );
                            })()}


                          </TableCell>

                          {activeFilter !== "cancelled" && (
                            <TableCell>
                              <Stack
                                direction="row"
                                spacing={0.5}
                                justifyContent="flex-start"
                                flexWrap="wrap"
                                useFlexGap
                              >
                                {(() => {
                                  const endTime = appointment.time.split(" - ")[1];
                                  const appointmentEndDateTime = new Date(
                                    `${appointment.rawDate.split("T")[0]}T${endTime}`
                                  );

                                  const isPastAppointment =
                                    appointmentEndDateTime < new Date();

                                  const canCancel =
                                    appointment.status?.toLowerCase() === "scheduled" &&
                                    !isPastAppointment &&
                                    isMoreThan2HoursBefore(
                                      appointment.startTime,
                                      appointment.rawDate
                                    );

                                  return canCancel ? (
                                    <Chip
                                      label="Cancel"
                                      size={isMobile ? "small" : "medium"}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCancelClick(appointment);
                                      }}
                                      sx={{
                                        backgroundColor: "transparent",
                                        border: "1px solid red",
                                        color: "red",
                                        "& .MuiChip-label": {
                                          px: { xs: 0.5, sm: 1 },
                                          fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                          color: "red",
                                        },
                                        borderRadius: 1,
                                        cursor: "pointer",
                                        "&:hover": {
                                          backgroundColor: "rgba(255, 0, 0, 0.04)",
                                        },
                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      label="Cancel"
                                      size={isMobile ? "small" : "medium"}
                                      disabled={isPastAppointment}
                                      onClick={(e) => {
                                        if (!isPastAppointment) {
                                          e.stopPropagation();
                                          handleCancelClick(appointment);
                                        }
                                      }}
                                      sx={{
                                        backgroundColor: "transparent",
                                        border: isPastAppointment
                                          ? "1px solid #ccc"
                                          : "1px solid red",
                                        color: isPastAppointment ? "#999" : "red",
                                        "& .MuiChip-label": {
                                          px: { xs: 0.5, sm: 1 },
                                          fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                          color: isPastAppointment ? "#999" : "red",
                                        },
                                        borderRadius: 1,
                                        cursor: isPastAppointment
                                          ? "not-allowed"
                                          : "pointer",
                                        "&:hover":
                                          !isPastAppointment
                                            ? {
                                              backgroundColor:
                                                "rgba(255, 0, 0, 0.04)",
                                            }
                                            : {},
                                      }}
                                    />
                                  );
                                })()}
                              </Stack>
                            </TableCell>
                          )}
                          {showModeColumn && (

                            <TableCell>
                              <Stack
                                direction="row"
                                spacing={0.5}
                                alignItems="center"
                              >
                                {/* {shouldShowModeChip(appointment) && (
                                <Chip
                                  icon={
                                    appointment.type?.toLowerCase() === 'video' ? (
                                      <VideoCallIcon sx={{ fontSize: 16 }} />
                                    ) : (
                                      <PhoneIcon sx={{ fontSize: 16 }} />
                                    )
                                  }
                                  label={appointment.type?.replace(/\b\w/g, c => c.toUpperCase())}
                                  size="small"
                                  disabled={!isModeEnabled(appointment)}
                                  onClick={(e) => handleConsultationClick(e, appointment)}
                                  sx={{
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    height: 32,
                                    borderRadius: 1,
                                    backgroundColor: appointment.type?.toLowerCase() === 'video' ? '#E0E7FF' : '#DCFCE7',
                                    color: appointment.type?.toLowerCase() === 'video' ? '#4338CA' : '#15803D',
                                    border: appointment.type?.toLowerCase() === 'video' ? '1px solid #A5B4FC' : '1px solid #86EFAC',
                                    '& .MuiChip-icon': { color: 'inherit' },
                                    '&:hover': {
                                      backgroundColor: appointment.type?.toLowerCase() === 'video' ? '#E0E7FF' : '#DCFCE7',
                                    },
                                  }}
                                />
                              )} */}
                                {shouldShowModeChip(appointment) && (
                                  <Chip
                                    // icon={
                                    //   appointment.type?.toLowerCase() === 'video' ? (
                                    //     <VideoCallIcon sx={{ fontSize: 16 }} />
                                    //   ) : (
                                    //     <PhoneIcon sx={{ fontSize: 16 }} />
                                    //   )
                                    // }
                                    label={
                                      appointment.type?.toLowerCase() === 'video'
                                        ? 'Join Session'
                                        : 'Initiate Call'
                                    }
                                    size="small"
                                    disabled={!isModeEnabled(appointment)}
                                    onClick={(e) => handleConsultationClick(e, appointment)}
                                    sx={{
                                      fontSize: '0.7rem',
                                      fontWeight: 600,
                                      height: 32,
                                      borderRadius: 1,
                                      backgroundColor:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '#E0E7FF'
                                          : '#DCFCE7',
                                      color:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '#4338CA'
                                          : '#15803D',
                                      border:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '1px solid #A5B4FC'
                                          : '1px solid #86EFAC',
                                      '& .MuiChip-icon': {
                                        color: 'inherit',
                                      },
                                      '&:hover': {
                                        backgroundColor:
                                          appointment.type?.toLowerCase() === 'video'
                                            ? '#E0E7FF'
                                            : '#DCFCE7',
                                      },
                                    }}
                                  />
                                )}
                                {/* {appointment.type?.toLowerCase() === 'video' && appointment.meetLink && ( */}
                                {shouldShowModeChip(appointment) &&
                                  isModeEnabled(appointment) &&
                                  appointment.type?.toLowerCase() === 'video' &&
                                  appointment.meetLink && (
                                    <Tooltip
                                      title={
                                        copiedAppointmentId === appointment.id
                                          ? 'Copied!'
                                          : 'Copy link'
                                      }
                                      arrow
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={async (e) => {
                                          await handleCopyMeetLink(e, appointment);

                                          setCopiedAppointmentId(appointment.id);

                                          setTimeout(() => {
                                            setCopiedAppointmentId(null);
                                          }, 2000);
                                        }}
                                        sx={{
                                          width: 30,
                                          height: 30,
                                          color: '#555',
                                          border: '1px solid #D1D5DB',
                                          borderRadius: 1,
                                          backgroundColor:
                                            copiedAppointmentId === appointment.id
                                              ? '#DCFCE7'
                                              : '#F5F5F5',

                                          '&:hover': {
                                            backgroundColor:
                                              copiedAppointmentId === appointment.id
                                                ? '#DCFCE7'
                                                : '#EEEEEE',
                                          },
                                        }}
                                      >
                                        <ContentCopyIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </Stack>
                            </TableCell>
                          )}
                          {/* {activeFilter === "cancelled" && (
                            <TableCell>
                              <Stack spacing={0.5}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {appointment.cancellationRemark || "-"}
                                </Typography>

                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {formatCancelledAt(appointment.cancelledAt)}

                                </Typography>
                              </Stack>
                            </TableCell>
                          )} */}

                          {activeFilter === "cancelled" && (
                            <TableCell>
                              <Stack spacing={0.5}>

                                {/* Cancelled date/time */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                      // color: "error.main",
                                    }}
                                  >
                                    Cancelled at:
                                  </Box>{" "}
                                  {formatCancelledAt(appointment.cancelledAt) || "-"}
                                </Typography>

                                {/* Cancelled by */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                    }}
                                  >
                                    Cancelled by:
                                  </Box>{" "}
                                  {["echoshine", "echobuddy"].includes(
                                    appointment.cancellationTriggeredBy?.toLowerCase()
                                  )
                                    ? "User"
                                    : appointment.cancellationTriggeredBy?.toLowerCase() ===
                                      "counsellor"
                                      ? "Counsellor"
                                      : appointment.cancellationTriggeredBy || "-"}
                                </Typography>

                                {/* Remark */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                    }}
                                  >
                                    Reason for Cancellation:
                                  </Box>{" "}
                                  {appointment.cancellationRemark || "-"}
                                </Typography>

                              </Stack>
                            </TableCell>
                          )}

                        </TableRow>
                      ))) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography variant="body2" color="text.secondary">
                          No appointments available.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={finalFilteredAppointments.length}
              rowsPerPage={rowsPerPage}
              sx={{
                '& .MuiTablePagination-toolbar': {
                  flexWrap: 'wrap',
                  gap: 1,
                  '& > *': {
                    my: 0.5
                  }
                },
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                  my: 0
                }
              }}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

          </Paper>
        </Grid>
      </Stack>

      {/* Appointment Details Dialog */}
      <Dialog
        open={openFeedbackDialog}
        onClose={() => setOpenFeedbackDialog(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        scroll="body"
        PaperProps={{
          sx: {
            fontFamily: theme.typography.fontFamily,
          }
        }}
        sx={{
          '& .MuiDialog-paper': {
            m: 0,
            width: '100%',
            maxHeight: '100%',
            '&.MuiDialog-paperFullScreen': {
              height: '100%',
              m: 0,
              borderRadius: 0
            }
          },
          '& .MuiDialogContent-root': {
            p: { xs: 2, sm: 3 },
            '&:first-of-type': {
              pt: { xs: 3, sm: 4 }
            }
          },
          '& .MuiDialogTitle-root': {
            p: { xs: 2, sm: 2 },
            pb: { xs: 1, sm: 2 },
            borderBottom: '1px solid',
            borderColor: 'divider'
          },
          '& .MuiDialogActions-root': {
            p: { xs: 2, sm: 1 },
            pt: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
            '&.MuiDialogActions-spacing > :not(:first-of-type)': {
              ml: 1.5
            }
          }
        }}
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" spacing={1}>
            {isMobile && (
              <IconButton
                edge="start"
                onClick={() => setOpenFeedbackDialog(false)}
                sx={{ mr: 0.5, ml: -1 }}
              >
                <ArrowLeft />
              </IconButton>
            )}
            <Typography variant="h6" component="div" sx={{ flex: 1 }}>
              {feedbackTab === 0 ? 'Appointment Details' : 'Leave Feedback'}
            </Typography>
            {!isMobile && (
              <IconButton
                edge="end"
                onClick={() => setOpenFeedbackDialog(false)}
                sx={{ mr: -1 }}
              >
                <X />
              </IconButton>
            )}
          </Stack>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            '&:first-of-type': {
              paddingTop: '10px !important',
            },
          }}
        >
          <Tabs
            value={feedbackTab}
            onChange={(e, newValue) => setFeedbackTab(newValue)}
            variant="fullWidth" // each tab takes equal width
            sx={{
              mb: 2,
              '& .MuiTabs-flexContainer': {
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  bgcolor: (theme) => theme.palette.divider,
                },
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
                minHeight: 48,
                '&.Mui-selected': {
                  color: (theme) => theme.palette.primary.main,
                },
                '&:not(:last-child)::after': {
                  content: '""',
                  position: 'absolute',
                  right: 0,
                  height: '95%',
                  width: '1px',
                  bgcolor: (theme) => theme.palette.primary.main,
                },
              },
            }}
          >
            <Tab label="Summary" />
            {selectedAppointment?.status === 'completed' && (
              <Tab label="Feedback" />
            )}
          </Tabs>

          {feedbackTab === 0 && selectedAppointment && (
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Doctor</Typography>
                    <Typography>
                      {selectedAppointment.doctorName}
                      {selectedAppointment.specialty && ` (${selectedAppointment.specialty})`}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Date & Time</Typography>
                    <Typography>{selectedAppointment.date} at {formatSlotToAMPM(selectedAppointment.time)}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                    <Chip
                      label={selectedAppointment.status.charAt(0).toUpperCase() + selectedAppointment.status.slice(1).toLowerCase()}
                      size={isMobile ? 'small' : 'medium'}
                      sx={{
                        backgroundColor: 'transparent', // ✅ remove gray background
                        border: selectedAppointment.status.toLowerCase() === 'scheduled' ? '1px solid green' : undefined,
                        color: selectedAppointment.status.toLowerCase() === 'scheduled' ? 'green' : undefined,
                        '& .MuiChip-label': {
                          px: { xs: 0.5, sm: 1 },
                          fontSize: { xs: '0.65rem', sm: '0.75rem' },
                          color: selectedAppointment.status.toLowerCase() === 'scheduled' ? 'green' : undefined,
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Type</Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      {getTypeIcon(selectedAppointment.type)}
                      <span>
                        {selectedAppointment.type.toLowerCase() === 'video'
                          ? 'Video Consultation'
                          : selectedAppointment.type.toLowerCase() === 'phone'
                            ? 'Phone Call'
                            : selectedAppointment.type}
                      </span>
                    </Stack>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Location/Details</Typography>
                    <Typography>{selectedAppointment.location || 'N/A'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {selectedAppointment.phone}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              {selectedAppointment.sessionNotes && (
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>Session Notes</Typography>
                  <Paper variant="outlined" sx={{ p: 2, minHeight: 200 }}>
                    <Typography>{selectedAppointment.sessionNotes}</Typography>
                  </Paper>
                </Grid>
              )}
            </Grid>
          )}

          {feedbackTab === 1 && selectedAppointment && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>How was your experience?</Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>Rate your experience</Typography>
                  <StyledRating
                    name="rating"
                    value={rating}
                    onChange={(event, newValue) => setRating(newValue)}
                    emptyIcon={<StarBorderIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                  />
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>What made your experience great?</Typography>
                  <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    mb: 2,
                    '& > *': {
                      m: '2px !important',
                      '&:first-of-type': {
                        ml: '0 !important'
                      }
                    }
                  }}>
                    {feedbackTagOptions.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        onClick={() => handleFeedbackTagToggle(tag)}
                        color={feedbackTags.includes(tag) ? 'primary' : 'default'}
                        variant={feedbackTags.includes(tag) ? 'filled' : 'outlined'}
                      />
                    ))}
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>Additional comments (optional)</Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Share more about your experience..."
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                  />
                </Box>

                <Box>
                  <Typography gutterBottom>Would you recommend this doctor?</Typography>
                  <Stack direction="row" spacing={2}>
                    <Button
                      size="small"
                      variant={recommend === 'yes' ? 'contained' : 'outlined'}
                      color="success"
                      startIcon={<ThumbUpIcon />}
                      onClick={() => setRecommend('yes')}
                      sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}
                    >
                      Yes
                    </Button>
                    <Button
                      size="small"
                      variant={recommend === 'no' ? 'contained' : 'outlined'}
                      color="error"
                      onClick={() => setRecommend('no')}
                      sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}
                    >
                      No
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'flex-end', // align buttons to the right
            position: isMobile ? 'sticky' : 'static',
            bottom: 0,
            bgcolor: 'background.paper',
            zIndex: 1,
            gap: 1, // spacing between buttons
            '& .MuiButton-root': {
              width: isMobile ? '100%' : '150px', // full width on mobile, fixed on desktop
            },
          }}
        >
          <Button onClick={() => setOpenFeedbackDialog(false)}>Close</Button>
          {feedbackTab === 1 && (
            <Button
              variant="contained"
              onClick={handleSubmitFeedback}
              disabled={!rating || !recommend}
            >
              Submit Feedback
            </Button>
          )}
        </DialogActions>

      </Dialog>

      {/* Snackbar for showing messages */}
      <Snackbar
        open={showSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setShowSnackbar(prev => ({ ...prev, open: false }))}
          severity={showSnackbar.severity || 'success'}
          sx={{ width: '100%' }}
        >
          {showSnackbar.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Cancel Appointment</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to cancel this appointment? This action cannot be undone.
          </Typography>
          <TextField
            label=" Reason of cancellation "
            placeholder="Please provide a reason for cancellation…"
            multiline
            rows={3}
            fullWidth
            required
            value={cancelRemark}
            onChange={(e) => setCancelRemark(e.target.value)}
            size="small"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDialogClose}>No, Keep It</Button>
          <Button
            onClick={handleConfirmCancel}
            variant="contained"
            color="error"
            disabled={!cancelRemark.trim()}
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box >
  );
};

export default MyAppointments;
